import { Fragment, useState } from "react"

import { Container, Tappable } from "@trueskin-web/components"

const ProductGallery = ({ slides }) => {
  const [selectedSlide, setSelectedSlide] = useState(0)

  const HeroImage = slides[selectedSlide]

  const handleClick = (slide) => {
    if (slide === selectedSlide) {
      return
    }

    setSelectedSlide(slide)
  }

  return (
    <Fragment>
      {HeroImage && (
        <div
          sx={{
            height: 375,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            background: "lightGray",
          }}
        >
          <HeroImage
            sx={{
              height: "100%",
            }}
          />
        </div>
      )}

      {slides.length > 1 && (
        <Container
          sx={{
            mt: 4,
            display: "flex",
            gap: 4,
            justifyContent: "center",
          }}
        >
          {slides.map((Slide, index) => (
            <Tappable
              key={index}
              onClick={() => handleClick(index)}
              sx={{
                justifyContent: "center",
                alignItems: "center",
                width: 72,
                height: 72,
                borderRadius: "8px",
                overflow: "hidden",
                transition: "all 0.3s",
                opacity: index === selectedSlide ? 1 : 0.3,
                variant: "vwo.components.productGallery.slide",
                background: "lightGray",
              }}
            >
              <Slide
                sx={{
                  height: 72,
                }}
              />
            </Tappable>
          ))}
        </Container>
      )}
    </Fragment>
  )
}

export default ProductGallery
